import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/report/summary", "documento": "invoices", "acceso": "sesion", "filas": ["031"], "cita": "prod:Areas/Invoices/Controllers/ReportsController.cs:70"} satisfies RutaProd;
